import { HttpInterceptorFn } from '@angular/common/http';
import {
    authenticationBaseUrl,
    environment,
    webhooksBaseUrl,
} from '../../../environments/environment';

/**
 * Cookie-based auth: necesitamos enviar cookies (sid HttpOnly) al backend.
 * - withCredentials es necesario cuando front/api están en distinto origin (dev típico).
 * - No añadimos Authorization header (no hay token en JS).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const url = req.url;
    const apiBase = environment.apiBaseUrl;

    const isBackend =
        url.startsWith(apiBase) ||
        url.includes(`${apiBase}/`) ||
        url.startsWith(authenticationBaseUrl) ||
        url.includes(`${authenticationBaseUrl}/`) ||
        url.startsWith(webhooksBaseUrl) ||
        url.includes(`${webhooksBaseUrl}/`);

    return next(isBackend ? req.clone({ withCredentials: true }) : req);
};
